import { useLocation } from "react-router-dom";
import { useCurrentSpaceContext } from "@circle-react/contexts";
import { usePunditUserContext } from "@circle-react/contexts";

export const useThumbnailView = () => {
  const { data: space } = useCurrentSpaceContext();
  const { pathname } = useLocation();
  const { currentCommunitySettings } = usePunditUserContext();
  const isAllEventsPage = pathname === "/events";
  const activeView = currentCommunitySettings?.public_events_view;

  return isAllEventsPage
    ? activeView === "thumbnail"
    : space?.display_view === "thumbnail";
};
